module.exports = __webpack_public_path__ + "img/V11heightLight.4e6c3a5c.png";